import { Controller } from "@hotwired/stimulus"

// Click/tap info hint (Atoms::InfoHintComponent); keeps the panel inside the viewport
export default class extends Controller {
  static targets = ["button", "panel"]

  toggle() {
    this.panelTarget.classList.contains("hidden") ? this.open() : this.close()
  }

  open() {
    // Position before showing: a panel that overflows even for one frame makes mobile Chrome zoom out
    const viewport = document.documentElement.clientWidth
    const anchor = this.element.getBoundingClientRect()
    const width = Math.min(288, viewport - 32) // w-72, max-w-[calc(100vw-2rem)]
    const alignRight = anchor.left + anchor.width / 2 > viewport / 2
    const left = alignRight ? anchor.right - width : anchor.left
    const shift = Math.max(12 - left, Math.min(0, viewport - 12 - (left + width)))

    this.panelTarget.classList.toggle("left-0", !alignRight)
    this.panelTarget.classList.toggle("right-0", alignRight)
    this.panelTarget.style.transform = shift ? `translateX(${shift}px)` : ""
    this.panelTarget.classList.remove("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.panelTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")
  }

  closeOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }
}
